import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49703ac4&scoped=true&lang=html&"
import script from "./advice.js?vue&type=script&lang=js&"
export * from "./advice.js?vue&type=script&lang=js&"
import style0 from "./advice.styl?vue&type=style&index=0&id=49703ac4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49703ac4",
  null
  
)

export default component.exports